import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { BRAND } from "../lib/siteData";

export default function FloatingWhatsApp() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={`https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(
        "Hi LNZ team, I'd like to discuss a project."
      )}`}
      target="_blank"
      rel="noreferrer"
      aria-label="Message on WhatsApp"
      className={`fixed bottom-6 right-6 z-50 group flex items-center gap-3 bg-[#25D366] text-white pl-4 pr-5 py-3.5 shadow-[0_10px_40px_-10px_rgba(37,211,102,0.8)] transition-all duration-500 hover:bg-[#1FB85A] ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
      data-testid="floating-whatsapp"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline text-sm font-bold tracking-wide">Chat on WhatsApp</span>
      <span className="absolute -top-1 -right-1 w-3 h-3 bg-[#F5A400] rounded-full animate-ping" />
      <span className="absolute -top-1 -right-1 w-3 h-3 bg-[#F5A400] rounded-full" />
    </a>
  );
}
